import styles from './Footer.module.scss'

const Footer = () => (
	<div className={styles.welcomeFooter}>
		<div className={styles.links}>
			<ul className={styles.social}>
				<li>
					<a
						href="https://www.facebook.com/nordicsemiconductor/"
						target="_blank"
					>
						<img src="/img/icons/social/facebook16x16.svg" alt="Facebook" />
					</a>
				</li>
				<li>
					<a
						href="https://www.linkedin.com/company/nordic-semiconductor/"
						target="_blank"
					>
						<img src="/img/icons/social/linkedin16x16.svg" alt="LinkedIn" />
					</a>
				</li>
				<li>
					<a href="https://www.youtube.com/user/NordicSemi" target="_blank">
						<img src="/img/icons/social/youtube16x16.svg" alt="YouTube" />
					</a>
				</li>
				<li>
					<a href="https://www.instagram.com/nordicsemi/" target="_blank">
						<img src="/img/icons/social/instagram16x16.svg" alt="Instagram" />
					</a>
				</li>
			</ul>
			<ul className={styles.nordic}>
				<li>
					<a href="https://www.nordicsemi.com/Privacy" target="_blank">
						Privacy Policy
					</a>
				</li>
				<li>
					<a
						href="https://www.nordicsemi.com/About-us/Contact-Us"
						target="_blank"
					>
						Contact Us
					</a>
				</li>
				<li>
					<a href="https://devzone.nordicsemi.com" target="_blank">
						DevZone
					</a>
				</li>
				<li>
					<a href="/tos.pdf" target="_blank">
						Terms of service
					</a>
				</li>
			</ul>
			<div className={styles.copyright}>
				&copy;{new Date().getFullYear()} Nordic Semiconductor. All rights
				reserved.
			</div>
		</div>
	</div>
)

export default Footer
